import AltProfilePic from '../Assets/profileIcon.png';
import useProfile from '../customHooks/useProfile';
import ProfileModal from './ProfileModal';
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';

const Header = () => {
    const [profile, setProfile] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const { checkProfileStatus } = useProfile();

    // Fetch doctor profile only once when the component loads
    useEffect(() => {
        const fetchProfile = async () => {
            const data = await checkProfileStatus(true);

            setProfile(data);
        };

        fetchProfile();
    }, []);

    return (
        <>
            <header className="fixed top-0 left-0 w-full bg-white z-50 bg-gradient-to-r from-green-500 to-blue-500 shadow-md">
                <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

                    <Link to="/dashboard" className="text-white font-bold text-2xl tracking-wide hover:opacity-90 transition">
                        MyBioTick
                    </Link>

                    <nav className="flex items-center gap-6">
                        <button
                            onClick={() => navigate('/patientrequests')}
                            className="p-2 rounded hover:bg-slate-300 hover:bg-opacity-20"
                        >
                            {/* Icon Code */}
                        </button>

                        {/* Profile Image */}
                        <div
                            onClick={() => setIsModalOpen(true)}
                            className="cursor-pointer"
                        >
                            <img
                                className="w-10 h-10 rounded-full object-cover border-2 border-white hover:scale-105 transition-transform duration-300"
                                src={profile?.image_url}
                                alt="Profile"
                                onError={(e) => {
                                    e.target.src = AltProfilePic;
                                }}
                            />

                        </div>
                    </nav>
                </div>
            </header>

            {/* Profile Modal */}
            <ProfileModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                data={profile}
            />
        </>
    );
};

export default Header;
